"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EGShield = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Styled = styled_components_1.default.a `
	overflow: hidden;
	width: ${(p) => p.theme.navHeight}px;
	height: ${(p) => p.theme.navHeight}px;
	padding: 8px 0;
	margin: 0;

	&& {
		${(p) => p.theme.breakpoints.down("xs")} {
			width: 48px;
		}
	}

	&:focus {
		outline-offset: -6px;
	}

	opacity: 0.9;
	transition: 0.2s opacity ${(p) => p.theme.easing};
	&:hover {
		opacity: 1;
		transition: 0.2s opacity ${(p) => p.theme.easing};
	}
`;
const EGShield = ({ locale, label = "Epic Games", variant, fill }) => {
    const href = `https://www.epicgames.com/store/${locale}/`;
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Styled, { href: href, role: "button", title: label, className: "shieldLogo", onMouseDown: epic_games_nav_shared_1.stopFocusOnClick },
        react_1.default.createElement(epic_games_nav_shared_1.EGShieldSvg, { label: label, variant: variant, fill: fill, hoverStyles: false }))), [locale]);
};
exports.EGShield = EGShield;
//# sourceMappingURL=EGShield.js.map